export default __webpack_public_path__ + "static/media/logout.359bdc91.svg";